module.exports = __webpack_public_path__ + "media/images/icon-main-edu-plus-402bad50836a89f5f284458ab7183a0f.svg";